namespace advisorop.components.advisor {

    class AdministrationAdvisorWrapperController {

        $router;
        public model: domains.IAdvisor;
        advisory: domains.IAdvisor;
        rolesNames: any;
        selectedCompanyGroup: domains.ICompanyGroup;
        advisors: Array<domains.IAdvisor> = [];

        static $inject = ["identityService", "generalService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService, private advisorService: services.AdvisorService) {

        }





        getAdvisorsForCurrentAdvisor(): void {
            this.advisorService.getAdvisorsForCurrentAdvisor()
                .success((data) => {
                    this.advisors = data;

                    //console.log("ADVISOR DETAIS");
                    //console.log(this.advisors);
                })
                .error((status, data) => {
                    toastr.error("GETADVISOR ERROR " + status + " " + data);
                });
        };


        //companyGroupSelected(companyGroup: domains.ICompanyGroup): void {
        //    this.selectedCompanyGroup = companyGroup;
        //};

        $onInit(): void {
            this.getAdvisorsForCurrentAdvisor(); 
        }


        $routerOnActivate(next, previous) {
        }
    }


    class AdministrationAdvisorWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdministrationAdvisorWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/administration-advisor-wrapper.html';
        }
    }
    angular.module(Constants.APP).component("administrationAdvisorWrapper", new AdministrationAdvisorWrapper());


}